import React from "react";
import { Col, Modal, Button } from "react-bootstrap";
import { TapirForm } from "./TapirForm";
import { SelectForm } from "../SelectForm";
import { TapirTable } from "./TapirTable";
import { TapirManager } from "./TapirManager";
import { GenericModal } from "../../usuario/GenericModal";
import { TitleAdmin } from "../TitleAdmin";
import { UserContext } from "../../UserContext";

export class TapirAdmin extends React.Component {
  static contextType = UserContext;
  state = {
    tapires: [],
    selectedTapir: null,
    collares: [],
    problematicos: [],
    selectedCollar: null,
    showError: false,
  };

  componentDidMount() {
    this.refreshData();
  }

  setTapires = (res) => {
    this.setState({ tapires: res.data });
  };
  setCollares = (res) => {
    this.setState({ collares: res.data });
  };
  setProblematicos = (res) => {
    this.setState({ problematicos: res.data });
  };

  errorBorrarTapir = (err) => {
    if (err.response.status === 405) {
      this.setState({ showError: true });
    }
    console.error(err);
  };

  // Para saber cual es el tapir que quiero editar, borrar, seguir o dejar de seguir.
  setSelectedTapir = (tapir) => {
    this.setState({ selectedTapir: tapir });
  };

  refreshData = () => {
    TapirManager.all(this.context.token, this.setTapires);
    TapirManager.collaresLibres(this.context.token, this.setCollares);
    TapirManager.collaresProblematicos(
      this.context.token,
      this.setProblematicos
    );
  };

  render() {
    const tableProps = {
      values: this.state.tapires,
      setSelected: this.setSelectedTapir,
    };
    const modal = {
      title: {
        crearEditar: "Tapir",
        seguirTapir: "Seguir tapir",
        borrarTapir: "Confirmación",
        dejarDeSeguir: "Confirmación",
      },
      bodyObj: {
        crearEditar: (props) => (
          <TapirForm
            initialValues={this.state.selectedTapir}
            onSubmit={(tapir) => {
              TapirManager.editOrCreate(
                this.context.token,
                tapir,
                // thenFunction
                () => TapirManager.all(this.context.token, this.setTapires)
              );
              props.hideModal();
            }}
          />
        ),
        seguirTapir: (props) => (
          <SelectForm
            options={this.state.collares}
            onSubmit={(values) => {
              TapirManager.seguir(
                this.context.token,
                values.elegido,
                this.state.selectedTapir.id,
                this.state.problematicos,
                // thenFunction
                this.refreshData
              );
              props.hideModal();
            }}
          />
        ),
        borrarTapir: () => <p>{"¿Está seguro que desea borrar el tapir?"}</p>,
        dejarDeSeguir: () => (
          <p>{"¿Está seguro que desea dejar de seguir el tapir?"}</p>
        ),
      },
      renderFooter: {
        borrarTapir: true,
        dejarDeSeguir: true,
      },
      yesAction: {
        borrarTapir: () =>
          TapirManager.delete(
            this.context.token,
            this.state.selectedTapir,
            //thenFunction
            this.refreshData,
            //catchFunction
            this.errorBorrarTapir
          ),
        dejarDeSeguir: () =>
          TapirManager.dejarDeSeguir(
            this.context.token,
            this.state.selectedTapir.tapirescollares_set[0],
            //thenFunction
            this.refreshData
          ),
      },
    };
    return (
      <Col>
        <GenericModal {...modal}>
          <TitleAdmin
            title="Tapires"
            tooltip="Nuevo tapir"
            onCrear={() => this.setSelectedTapir(undefined)}
          />
          <TapirTable {...tableProps} />
        </GenericModal>
        <Modal
          show={this.state.showError}
          onHide={() => this.setState({ showError: false })}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              "No se puede borrar el tapir. Es posible que tenga mediciones asociadas."
            }
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showError: false })}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </Col>
    );
  }
}
